// extracted by mini-css-extract-plugin
export default {"wrapper":"MainActorsList_wrapper__6oM76","title":"MainActorsList_title__qPTCz","cardWrapper":"MainActorsList_cardWrapper__V+42o"};